var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTableAG',{attrs:{"rowHeight":55,"columns":_vm.columns,"getcontentpath":_vm.getforgetmepath,"jsonobject":"forgetme","buttonList":['Poista asiakkaan tiedot'],"width":"1200px","height":"750px","archivecontentpath":"2.0/newbe/deletenotifications","archiveparam":"notificationids"},on:{"pressed-button1":_vm.deleteRequest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }